import React from 'react'
import { Button } from 'semantic-ui-react'
import * as Config from '../../../public/external-links'
import Accordion from '../../common/Accordion'

export const AnnualLeaveAgreementFooter = (props) => {
  return (
    <Accordion
      heading="Your template letter is now ready"
      expanded={props.show}
      onClick={() => props.setShow()}
    >
      <p>You can download your letter to your device.</p>
      <p>
        This will create a Word document that you can review and edit before you
        send it to your employee.
      </p>
      <h2>Important information</h2>
      <p>
        You should carefully check the terms in your template agreement to make
        sure you have met any award or agreement requirements. You may wish to
        seek professional advice.
      </p>
      <h2>Save to your device</h2>
      <Button className="ui is-primary button" onClick={props.handleDownload}>
        Download
      </Button>
      <p>
        Annual leave is paid at the employee&#39;s base pay rate for all
        ordinary hours worked.
      </p>
      <p>
        If annual leave falls over a period that includes a public holiday,
        full-time and part-time employees must be paid their ordinary pay for
        that day – this doesn&#39;t come out of their annual leave balances.
      </p>
      <p>
        Some awards and enterprise agreements also provide employees with an
        additional loading while on annual leave.
      </p>
      <p>
        Use our{' '}
        <a
          target="_blank"
          href={Config.INTERACTIVE_TEMPLATE_LEAVE_CALCULATOR}
          rel="noreferrer"
          className="external-link"
        >
          Leave Calculator
        </a>{' '}
        to calculate leave balances and annual leave loading entitlements for
        your employees.
      </p>
      <p>
        Find out more about{' '}
        <a
          target="_blank"
          href={Config.INTERACTIVE_TEMPLATE_PAYMENT_ANNUAL_LEAVE}
          rel="noreferrer"
          className="external-link"
        >
          payment of annual leave
        </a>
        .
      </p>
    </Accordion>
  )
}
